import React, { Component } from "react";
import { Container, Icon, Image, Grid } from "semantic-ui-react";

import PageHeader from "../liminal/PageHeader";
import PageFooter from "../liminal/PageFooter";
import raw from "raw.macro";
import ReactMarkdown from "react-markdown";

import universiteitLeiden from "../../assets/images/partners/universiteit_leiden.jpg";
import universiteitTwente from "../../assets/images/partners/universiteit_twente.jpg";
import rijksuniversiteitGroningen from "../../assets/images/partners/rijksuniversiteit_groningen.png";
import brill from "../../assets/images/partners/brill.png";
import nwo from "../../assets/images/partners/nwo.jpg";
import naturalis from "../../assets/images/partners/naturalis.jpg";

const ABOUT = {
  main: raw('md/about.md'),
  project: raw('md/project.md'),
  partners: raw('md/partners.md'),
};

function Back(props) {
  if (props.page !== "main") {
    return <a href={`${process.env.REACT_APP_URL_PATH}/about`}><Icon name='arrow left' size='small' /> Back</a>
  }
  else  {
    return ''
  }
}

class AboutPage extends Component {
  constructor(props) {
    super(props);
    this.state = { searchTerm: "" };
  }
  render() {
    return (
      <div className="about-page wrapper">
        <PageHeader search={this.props.search} history={this.props.history} />
        <Container text>
          <Back page={this.props.page} />
          <ReactMarkdown source={this.props.page in ABOUT ? ABOUT[this.props.page] : ABOUT["main"]} />
          <Grid relaxed centered columns={3} stackable>
            <Grid.Column>
              <Image src={universiteitLeiden} centered size='medium' href="https://www.universiteitleiden.nl/" />
            </Grid.Column>
            <Grid.Column>
              <Image src={universiteitTwente} centered size='medium' href="https://www.utwente.nl/" />
            </Grid.Column>
            <Grid.Column>
              <Image src={rijksuniversiteitGroningen} centered size='medium' href="https://www.rug.nl/" />
            </Grid.Column>
            <Grid.Column>
              <Image src={brill} centered size='small' href="https://brill.com/" />
            </Grid.Column>
            <Grid.Column>
              <Image src={nwo} centered size='small' href="https://www.nwo.nl/" />
            </Grid.Column>
            <Grid.Column>
              <Image src={naturalis} centered size='small' href="https://www.naturalis.nl/" />
            </Grid.Column>
          </Grid>
        </Container>
        <PageFooter />
      </div>
    );
  }
}
export { AboutPage };
